import React from 'react';
import { useParams } from "react-router-dom";
import { useQuery } from 'react-query';
import { useEnergyApi } from '../_api/EnergyApiContext';
import RecRegistryBundleSnapshotDataTable from './_components/RecRegistryBundleSnapshotDataTable'
import PropTypes from 'prop-types';
import {
  Switch,
  Route,
  Link as RouteLink,
  useRouteMatch,
} from 'react-router-dom';

export const CertificateBundleSnapshot: React.FC = (): React.ReactElement => {
  const match = useRouteMatch()
  // const [filter, setFilter] = React.useState({} as CertificateBundleSnapshotFilterData)

  return (
    <Switch>
      <Route path={`${match.path}/:snapshotId`}>
        <h1>Snapshot</h1>
      </Route>
      <Route>
        <h1>Snapshots</h1>
        <RecRegistryBundleSnapshotDataTable />
      </Route>
    </Switch>
  )
}

export default CertificateBundleSnapshot
